import { THEMED_TEXT_CLASSES } from '../constants';

export const themedTextClass = (isManagerSite) =>
  isManagerSite ? THEMED_TEXT_CLASSES.DEFAULT : THEMED_TEXT_CLASSES.PORTAL;
